import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M3,5.5 C1.61928813,5.5 0.5,4.38071187 0.5,3 C0.5,1.61928813 1.61928813,0.5 3,0.5 C4.38071187,0.5 5.5,1.61928813 5.5,3 C5.5,4.38071187 4.38071187,5.5 3,5.5 Z M10,5.5 C8.61928813,5.5 7.5,4.38071187 7.5,3 C7.5,1.61928813 8.61928813,0.5 10,0.5 C11.3807119,0.5 12.5,1.61928813 12.5,3 C12.5,4.38071187 11.3807119,5.5 10,5.5 Z M17,5.5 C15.6192881,5.5 14.5,4.38071187 14.5,3 C14.5,1.61928813 15.6192881,0.5 17,0.5 C18.3807119,0.5 19.5,1.61928813 19.5,3 C19.5,4.38071187 18.3807119,5.5 17,5.5 Z"
      transform="translate(2 9)"
      fill={fill}
    />
  </g>
);

export default Icon;
